/**
 * @file index.tsx
 *
 * @fileoverview Shows form elements inline.
 */
import { ReactNode } from 'react';
import FlexItem from '../../../02-atoms/06-layout/03-flex/02-flex-item';
import styles from './formItemsInline.module.scss';

export interface FormItemsInlineProps {
  /**
   * Elements to include inside.
   */
  inputs: ReactNode[];
  /**
   * The submit button.
   */
  button: ReactNode;
}

export default function FormItemsInline({
  inputs,
  button,
}: FormItemsInlineProps) {
  return (
    <div className={styles.itemsWrapper}>
      <div className={styles.flexItems}>
        {inputs.map((input, index) => {
          return (
            inputs && (
              <FlexItem
                className={`jcl-flex-item-element ${styles.childFlexItem}`}
                key={index}
              >
                {input}
              </FlexItem>
            )
          );
        })}
        {button}
      </div>
    </div>
  );
}
export { FormItemsInline };
